import React, { useEffect, useState, useRef } from 'react';
import mysiteInspectionLogo from './img/mysiteInspectionLogo.png';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { apiCall } from "../../services/ApiCall";
import config from "../../config/config.json";
import PDF from './pdf';
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import { S3 } from 'aws-sdk';
import { Button, Form, Modal } from 'react-bootstrap';
import html2pdf from 'html2pdf.js';
import ReassignModal from './ReassignModal';
import { CanWrite, CanAssignRequest } from '../../context/AuthContext';

const VieInspectionReportPDF = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [uploadedImages, setUploadedImages] = useState({});
  const [modules, setModules] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [requestData, setRequestData] = useState();
  const [desabled, setDesabled] = useState(false);
  const pdfRef = useRef();
  const [redoShow, setRedoShow] = useState(false);
  const [redoDataChecked, setRedoDataChecked] = useState(false);
  const [redoPictureChecked, setRedoPictureChecked] = useState(false);
  const [dataTextArea, setDataTextArea] = useState('');
  const [pictureTextArea, setPictureTextArea] = useState('');
  const [reassignShow, setReassignShow] = useState(false);

  const handleClose = () => {
    setRedoShow(false);
    setRedoDataChecked(false);
    setRedoPictureChecked(false);
    setDataTextArea('');
    setPictureTextArea('');
  }
  const handleShow = () => setRedoShow(true);
  const handleReassignShow = () => setReassignShow(true);
  const handleReassignClose = () => setReassignShow(false);
  const handleReassignSuccess = () => {

    getRequestUserData();
  };

  const reApproveRequest = async () => {
    try {
      const { isSuccess, data } = await apiCall(
        `${config.POST_LOGIN_API_URL}reApproveRequest`,
        {},
        { requestId: parseInt(location.state?.requestId) },
        "POST"
      );
      if (isSuccess) {
        getRequestUserData();
      }
    } catch (error) {
      console.error("Failed to re-approve request:", error);

    }
  };

  const getRequestUserData = async () => {
    try {
      const { isSuccess, data } = await apiCall(
        `${config.POST_LOGIN_API_URL}getRequestUserData`,
        {},
        { requestId: location.state?.requestId },
        "GET"
      );
      if (isSuccess) {
        setRequestData(data.data);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };
  const syncToZoho = async () => {
    try {
      const { isSuccess, data } = await apiCall(
        `${config.POST_LOGIN_API_URL}syncToZoho`,
        {},
        { requestId: location.state?.requestId },
        "POST"
      );
      if (isSuccess) {
      }

    } catch (error) {
      console.error("Failed to fetch data:", error);

    }
  };

  const approveRequest = async () => {
    try {
      const { isSuccess, data } = await apiCall(
        `${config.POST_LOGIN_API_URL}approveRequest`,
        {},
        { requestId: location.state?.requestId },
        "POST"
      );
      if (isSuccess) {
      }

    } catch (error) {
      console.error("Failed to fetch data:", error);

    }
  };

  const sendToNewRequest = async () => {
    try {
      const { isSuccess, data } = await apiCall(
        `${config.POST_LOGIN_API_URL}sendToNewRequest`,
        {},
        {
          requestId: location.state?.requestId
        },
        "POST"
      );
      if (isSuccess) {
        handleClose();
      }

    } catch (error) {
      console.error("Failed to fetch data:", error);

    }
  };
  const validateRedoInput = () => {
    const messages = [];
    if (redoDataChecked && dataTextArea.trim() === '') {
      messages.push('Please enter comments for site admin');
    }
    if (redoPictureChecked && pictureTextArea.trim() === '') {
      messages.push('Please enter comments for site manager');
    }
    if (!redoDataChecked && dataTextArea.trim() !== '') {
      messages.push('Please clear comments for site admin if you want to unselect the checkbox');
    }
    if (!redoPictureChecked && pictureTextArea.trim() !== '') {
      messages.push('Please clear comments for site manager if you want to unselect the checkbox');
    }
    if (!redoDataChecked && !redoPictureChecked) {
      messages.push('Please select at least one checkbox');
    }
    return { error: messages.length > 0, messages: messages };
  }
  // Validation function to check if save button should be disabled
  const isSaveDisabled = () => {
    const { error, messages } = validateRedoInput();
    if (error) {
      return { error: true, messages: messages };
    }
    return { error: false, messages: [] };
  };

  const redoRequest = async () => {
    // Prevent save if validation fails
    if (isSaveDisabled()?.error) {
      return;
    }

    try {
      const { isSuccess, data } = await apiCall(
        `${config.POST_LOGIN_API_URL}redoRequest`,
        {},
        {
          requestId: location.state?.requestId, redoDataChecked, redoPictureChecked, dataTextArea, pictureTextArea
        },
        "POST"
      );
      if (isSuccess) {
        handleClose();
      }

    } catch (error) {
      console.error("Failed to fetch data:", error);

    }
  };

  const getRequestPictures = async () => {
    if (location.state?.requestId) {
      try {
        const { isSuccess, data } = await apiCall(
          `${config.POST_LOGIN_API_URL}getRequestPictures`,
          {},
          { requestId: location.state?.requestId },
          "GET"
        );
        if (isSuccess && data.data.length) {
          setUploadedImages(data.data[0]);
          console.log("Uploaded Images:", data.data[0]);

        }
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    }
  };

  const getDataFormQuestionList = async () => {
    try {
      const { isSuccess, data } = await apiCall(
        `${config.POST_LOGIN_API_URL}getPDFQuestions`,
        {},
        { type: "ALL" },
        "GET"
      );
      if (isSuccess && Array.isArray(data.data)) {
        setModules(data.data);
      } else {
        console.error("API response is not an array:", data);
        setModules([]);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setModules([]);
    }
  };

  const getRequestDataFormAnswer = async () => {
    try {
      const { isSuccess, data } = await apiCall(
        `${config.POST_LOGIN_API_URL}getRequestDataFormAnswer`,
        {},
        { requestId: location.state?.requestId },
        "GET"
      );
      if (isSuccess) {
        setAnswers(data.data);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  const s3 = new S3({
    accessKeyId: 'AKIAR4KASQXIS5GCSYGH',
    secretAccessKey: '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',
    region: 'us-east-1',
  });

  const toDataURL = (url) => {
    if (url) {
      return new Promise((resolve, reject) => {
        const getRequestDataFormAnswer = async () => {
          try {
            const { isSuccess, data } = await apiCall(
              `${config.POST_LOGIN_API_URL}getProxyImageUrl`,
              {},
              { url: encodeURIComponent(url) },
              "GET"
            );

            if (isSuccess && data && data.data) {
              const proxyUrl = `data:image/jpeg;base64,${data.data}`;

              const img = new Image();

              img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                resolve(canvas.toDataURL('image/jpeg', 0.6));
              };

              img.onerror = (error) => reject(error);
              img.src = proxyUrl;
            } else {
              reject(new Error('Image data not available from proxy.'));
            }
          } catch (error) {
            console.error("Failed to fetch data:", error);
            reject(error);
          }
        };

        getRequestDataFormAnswer();
      });
    }
  };


  const replaceImagesWithBase64 = async () => {
    const images = [...document.querySelectorAll('img')].slice(1);

    const imagePromises = Array.from(images).map(async (img) => {
      const src = img.src;
      const reportId = img.getAttribute('reportId');
      if (!src.startsWith('data:')) {
        try {
          img.src = await toDataURL(uploadedImages[reportId]);
        } catch (error) {
          console.error('Failed to convert to Base64 for:', src, error);
        }
      }
    });
    await Promise.all(imagePromises);
  };
  const waitForImages = async (element) => {
    const images = Array.from(element.querySelectorAll('img'));
    await Promise.all(
      images.map((img) => {
        return new Promise((resolve) => {
          if (img.complete && img.naturalWidth > 0) {
            resolve();
            return;
          }
          img.onload = () => resolve();
          img.onerror = () => resolve();
        });
      })
    );
  };

  const replaceFormControlsForPDF = (container) => {
    const doc = container.ownerDocument || document;
    const controls = container.querySelectorAll('input.form-check-input');
    controls.forEach((input) => {
      const replacement = doc.createElement('span');
      const isRadio = input.type === 'radio';
      const isChecked = input.checked;

      replacement.style.display = 'inline-block';
      replacement.style.width = '16px';
      replacement.style.height = '16px';
      replacement.style.border = '1px solid #000';
      replacement.style.boxSizing = 'border-box';
      replacement.style.borderRadius = isRadio ? '50%' : '3px';
      replacement.style.backgroundColor = '#fff';
      replacement.style.marginRight = '6px';
      replacement.style.verticalAlign = 'middle';

      if (isChecked) {
        if (isRadio) {
          const dot = doc.createElement('span');
          dot.style.display = 'block';
          dot.style.width = '8px';
          dot.style.height = '8px';
          dot.style.margin = '3px';
          dot.style.borderRadius = '50%';
          dot.style.backgroundColor = '#000';
          replacement.appendChild(dot);
        } else {
          replacement.textContent = '✓';
          replacement.style.textAlign = 'center';
          replacement.style.lineHeight = '14px';
          replacement.style.fontSize = '12px';
          replacement.style.fontWeight = 'bold';
        }
      }

      if (input.parentNode) {
        input.parentNode.replaceChild(replacement, input);
      }
    });
  };

  const getUploadedImageCount = (data) => {
    if (!data) return 0;

    return Object.keys(data).filter(
      (key) =>
        /^p\d+$/.test(key) &&
        typeof data[key] === 'string' &&
        data[key].trim() !== ''
    ).length;
  };
  const checkImagesStatus = () => {
    const element = pdfRef.current;

    if (!element) {
      return {
        expected: 0,
        total: 0,
        loaded: 0,
        failed: 0,
        loading: 0,
        allLoaded: false,
      };
    }

    // Expected images from API
    const expected = getUploadedImageCount(uploadedImages);

    // Images currently rendered in DOM
    const images = Array.from(
      element.querySelectorAll('img[reportId]')
    );

    const loaded = images.filter(
      (img) => img.complete && img.naturalWidth > 0
    );

    const failed = images.filter(
      (img) => img.complete && img.naturalWidth === 0
    );

    const loading = images.filter(
      (img) => !img.complete
    );

    // IMPORTANT:
    // DOM count must equal API count
    // AND all DOM images must be successfully loaded
    const allLoaded =
      loaded.length >= expected &&
      failed.length === 0 &&
      loading.length === 0;

    const result = {
      expected,
      total: images.length,
      loaded: loaded.length,
      failed: failed.length,
      loading: loading.length,
      allLoaded,
    };

    console.log('IMAGE STATUS:', result);

    return result;
  };

  const generatePDF = async () => {
    try {
      const status = checkImagesStatus();

      if (!status.allLoaded) {
        alert('Cannot generate PDF. Some images are still loading. Please wait and try again.');
        return;
      }
      setDesabled(true);

      // Step 1: convert all remote images to base64 via your proxy — avoids CORS/tainting entirely
      await replaceImagesWithBase64();

      const element = pdfRef.current;
      if (!element) throw new Error('PDF element not found');

      // Step 2: now that srcs are base64, confirm they've actually rendered
      await waitForImages(element);

      // PDF dimensions: A3 portrait (297mm x 420mm) with 10mm margins
      // Printable content width = 277mm, printable content height = 400mm
      const marginMm = 10;
      const pdfInnerWidthMm = 277;
      const pdfInnerHeightMm = 400;
      const pageRatio = pdfInnerHeightMm / pdfInnerWidthMm; // ~1.44404332

      const canvas = await html2canvas(element, {
        scale: 1.5,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#FFFFFF',
        logging: false,
        onclone: (clonedDoc) => {
          replaceFormControlsForPDF(clonedDoc);

          const clonedTarget = clonedDoc.getElementById('pdf-report-root') || clonedDoc.body;
          const rootRect = clonedTarget.getBoundingClientRect();
          const rootTop = rootRect.top;
          const renderWidth = clonedTarget.offsetWidth || element.offsetWidth || 1100;
          const pageHeightPx = Math.floor(renderWidth * pageRatio);

          let currentPageBottom = pageHeightPx;
          const avoidElements = Array.from(clonedTarget.querySelectorAll('.pdf-no-break'));

          for (let i = 0; i < avoidElements.length; i++) {
            const el = avoidElements[i];
            const elRect = el.getBoundingClientRect();
            const elTop = elRect.top - rootTop;
            const elBottom = elRect.bottom - rootTop;
            const elHeight = elRect.height;

            if (elHeight <= pageHeightPx) {
              if (elBottom > currentPageBottom && elTop < currentPageBottom) {
                const spacerHeight = currentPageBottom - elTop;
                const spacer = clonedDoc.createElement('div');
                spacer.className = 'pdf-page-spacer';
                spacer.style.height = `${spacerHeight}px`;
                spacer.style.width = '100%';
                spacer.style.display = 'block';
                spacer.style.clear = 'both';
                spacer.style.margin = '0';
                spacer.style.padding = '0';

                el.parentNode.insertBefore(spacer, el);
                currentPageBottom += pageHeightPx;
              } else if (elTop >= currentPageBottom) {
                while (elTop >= currentPageBottom) {
                  currentPageBottom += pageHeightPx;
                }
                const newElRect = el.getBoundingClientRect();
                const newElTop = newElRect.top - rootTop;
                const newElBottom = newElRect.bottom - rootTop;
                if (newElBottom > currentPageBottom) {
                  const spacerHeight = currentPageBottom - newElTop;
                  const spacer = clonedDoc.createElement('div');
                  spacer.className = 'pdf-page-spacer';
                  spacer.style.height = `${spacerHeight}px`;
                  spacer.style.width = '100%';
                  spacer.style.display = 'block';
                  spacer.style.clear = 'both';
                  spacer.style.margin = '0';
                  spacer.style.padding = '0';

                  el.parentNode.insertBefore(spacer, el);
                  currentPageBottom += pageHeightPx;
                }
              }
            }
          }
        }
      });

      // Create the PDF document
      const pdf = new jsPDF({
        unit: 'mm',
        format: 'a3',
        orientation: 'portrait',
        compress: true
      });

      const canvasWidth = canvas.width;
      const canvasTotalHeight = canvas.height;
      const canvasPageHeight = Math.round(canvasWidth * pageRatio);
      const totalPages = Math.ceil(canvasTotalHeight / canvasPageHeight);

      for (let page = 0; page < totalPages; page++) {
        if (page > 0) {
          pdf.addPage();
        }

        const pageCanvas = document.createElement('canvas');
        pageCanvas.width = canvasWidth;
        pageCanvas.height = canvasPageHeight;
        const pageCtx = pageCanvas.getContext('2d');

        // Fill background with white
        pageCtx.fillStyle = '#FFFFFF';
        pageCtx.fillRect(0, 0, canvasWidth, canvasPageHeight);

        const sY = page * canvasPageHeight;
        const sHeight = Math.min(canvasPageHeight, canvasTotalHeight - sY);

        pageCtx.drawImage(
          canvas,
          0, sY, canvasWidth, sHeight,
          0, 0, canvasWidth, sHeight
        );

        const pageImgData = pageCanvas.toDataURL('image/jpeg', 0.95);
        pdf.addImage(
          pageImgData,
          'JPEG',
          marginMm,
          marginMm,
          pdfInnerWidthMm,
          pdfInnerHeightMm,
          undefined,
          'FAST'
        );
      }

      const companyName = requestData?.companyName || location.state?.requestData?.companyName || 'Report';
      const reqId = requestData?.id || requestData?.requestId || location.state?.requestData?.requestId || location.state?.requestId || 'inspection';
      const filename = `${companyName}_${reqId}.pdf`;

      pdf.save(filename);
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Something went wrong while generating the PDF. Please try again.');
    } finally {
      setDesabled(false);
    }
  };

  const uploadToS3 = async (pdfBlob) => {
    try {
      const timestamp = new Date().getTime();
      const fileName = `${timestamp}_report.pdf`;
      const formData = new FormData();
      formData.append("file", pdfBlob, fileName);
      formData.append("fileName", fileName);
      formData.append("filePath", "msi/");

      const requestOptions = {
        method: "POST",
        body: formData,
      };

      const response = await fetch(`${config.AUTH_API_URL}uploadFile`, requestOptions);
      if (!response.ok) {
        throw new Error("Failed to upload file");
      }

      const result = await response.json();
      const url = result.url;
      console.log('PDF uploaded successfully. File URL:', url);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName); // Set the download attribute
      document.body.appendChild(link); // Append the link to the body
      link.click(); // Programmatically trigger the click event to download
      document.body.removeChild(link); // Remove the link after download
    } catch (error) {
      console.error("Error:", error);
    }
  };


  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
    } else {
      getDataFormQuestionList();
      getRequestUserData();
      getRequestPictures();
      getRequestDataFormAnswer();
    }
  }, [navigate]);

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <div style={styles.headerLeft}>
          <CanWrite>
            <Link to="/request-form" state={{ requestId: location.state?.requestId }}>
              <button style={styles.headerButton}>Edit Request</button>
            </Link>
            <button style={styles.headerButton} onClick={syncToZoho}>Sync To Zoho</button>
            <button onClick={generatePDF} style={styles.headerButton} disabled={desabled}>{desabled ? 'Generating' : 'Generate PDF'} </button>
            {requestData?.status == '2' && <>
              <button style={styles.headerButton} onClick={handleShow}>Re Do</button>
              <button style={styles.headerButton} onClick={approveRequest}>Approve</button>
            </>}
            {requestData?.status == '4' && <>
              <button style={styles.headerButton} onClick={handleShow}>Re Do</button>
              <button style={styles.headerButton} onClick={sendToNewRequest}>Send To New Request</button>
              <button style={styles.headerButton} onClick={reApproveRequest}>Re-Approve</button>
            </>}
          </CanWrite>
          <CanAssignRequest>
            <button style={styles.headerButton} onClick={handleReassignShow}>Reassign</button>
          </CanAssignRequest>
        </div>
      </header>
      <div ref={pdfRef} id="pdf-report-root">
        <div className='header pdf-no-break' style={{ backgroundColor: '#DCEDFF', padding: '30px', borderRadius: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)' }}>

          <div>
            <img
              src={mysiteInspectionLogo} alt="MySiteInspection.com"
              style={styles.logo}
            />
          </div>
          <div>
            <span style={{ marginRight: '1em' }}>Support@mysiteinspection.com</span>
            <strong style={{ marginRight: '1em' }}>(401) 463-0200</strong>
          </div>
        </div>

        <div className='pdf-no-break' style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ fontSize: "29px", fontWeight: 600 }}>
            Site Inspection Compliance Report
          </div>
        </div>

        <div >
          {modules.map((module, index) => (
            <PDF requestData={requestData} index={index} module={module} answer={answers[module.moduleTitle]} />
          ))}
        </div>

        <Modal show={redoShow} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Re-Do</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Check
                type="checkbox"
                label="ReDo-Data Form"
                checked={redoDataChecked}
                onChange={() => setRedoDataChecked(!redoDataChecked)}
              />
              {redoDataChecked && (
                <div>
                  <Form.Group controlId="dataInput">
                    <Form.Label>Site Admin Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={requestData?.siteAdminName}
                      readOnly
                    />
                    <Form.Label>Site Admin Email</Form.Label>
                    <Form.Control
                      type="text"
                      value={requestData?.siteAdminEmail}
                      readOnly
                    />
                  </Form.Group>
                  <Form.Group controlId="dataTextArea">
                    <Form.Label>Comments For Site Admin</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={dataTextArea}
                      onChange={(e) => setDataTextArea(e.target.value)}
                    />
                  </Form.Group>
                </div>
              )}

              <Form.Check
                type="checkbox"
                label="ReDo-Picture Form"
                className='mt-4'
                checked={redoPictureChecked}
                onChange={() => setRedoPictureChecked(!redoPictureChecked)}
              />
              {redoPictureChecked && (
                <div>
                  <Form.Group controlId="pictureInput">
                    <Form.Label>Site Manager Control</Form.Label>
                    <Form.Control
                      type="text"
                      readOnly
                      value={requestData?.siteManagerName}
                    />
                    <Form.Label>Site Manager Email</Form.Label>
                    <Form.Control
                      type="text"
                      readOnly
                      value={requestData?.siteManagerEmail}
                    />
                  </Form.Group>
                  <Form.Group controlId="pictureTextArea">
                    <Form.Label>Comments For Site Manager</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={pictureTextArea}
                      onChange={(e) => setPictureTextArea(e.target.value)}
                    />
                  </Form.Group>
                </div>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex flex-column w-100">
              {isSaveDisabled()?.error && (
                <div className="text-danger mb-2 small">
                  {isSaveDisabled()?.messages?.map((message, index) => (
                    <div key={index}>{message}</div>
                  ))}
                </div>
              )}
              <div className="d-flex justify-content-end">
                <Button
                  variant="primary"
                  onClick={redoRequest}
                  disabled={isSaveDisabled()?.error}
                >
                  Save
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

      </div>

      <ReassignModal
        show={reassignShow}
        onHide={handleReassignClose}
        requestId={location.state?.requestId}
        companyId={requestData?.companyId || location.state?.companyId}
        siteId={requestData?.siteId || location.state?.siteId}
        onSuccess={handleReassignSuccess}
      />
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    color: '#333',
  },
  logo: {
    height: '40px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1em'
  },
  headerLeft: {
    display: 'flex',
    gap: '10px',
  },
  headerButton: {
    backgroundColor: '#0050A4',
    color: 'white',
    border: 'none',
    marginRight: '2em',
    padding: '10px 15px',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  generatePDFButton: {
    backgroundColor: '#0050A4',
    color: 'white',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '20px',
  },
};

export default VieInspectionReportPDF;
